import { RaisedButton } from 'material-ui';
import React, { Component } from 'react';
import Alert from 'react-s-alert';
import { alertConfirmation } from '../../../../../../../../actions/utilAction';
import {MAX_DURATION_TIME} from '../../constants/TimerConstants';


function formatTime(seconds) {
  if (seconds === null || seconds === undefined || seconds <= 0) {
      return "0:00";
  }

  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;

  return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
}

  
// pause when i leave page issue
class Timer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      seconds: 0,
      isRunning: false,
      wasPaused: false,
      lastUpdateTime: null,
      userID: props.userID,
      patientID: props.patientID
    };
    this.storageKey = `timer-state-${this.props.id}`;
    this.intervalId = null;
  }

  componentDidMount() {
    const storedTimerState = localStorage.getItem(this.storageKey);
    if (storedTimerState) {
      const timerState = JSON.parse(storedTimerState);
      if(!timerState.userID){
          const currentTime = Date.now();
          const timeDiff = Math.round((currentTime - timerState.lastUpdateTime) / 1000);
          let second = timerState.seconds;
          if(timerState.isRunning){
              second = second + timeDiff;
          }
          this.setState({
              seconds: second >= MAX_DURATION_TIME? MAX_DURATION_TIME: second,
              isRunning:timerState.isRunning,
              wasPaused: timerState.wasPaused,
              userID: this.props.userID,
              patientID: this.props.patientID,
              lastUpdateTime: currentTime,
          });
          if (timerState.isRunning && !timerState.wasPaused) {
            this.startTimer();
          }
      } else {
        if (timerState.userID !== this.props.userID){
          localStorage.removeItem(this.storageKey);
        }else{
          if(timerState.patientID !== this.props.patientID){
            localStorage.removeItem(this.storageKey)
          }else{
            const currentTime = Date.now();
            const timeDiff = Math.round((currentTime - timerState.lastUpdateTime) / 1000);
            let second = timerState.seconds;
            if(timerState.isRunning){
                second = second + timeDiff;
            }
            this.setState({
                seconds: second  ,
                isRunning:timerState.isRunning,
                wasPaused: timerState.wasPaused,
                userID: this.props.userID,
                patientID: this.props.patientID,
                lastUpdateTime: currentTime,
            });
            if (timerState.isRunning && !timerState.wasPaused) {
              this.startTimer();
            }
          }
        } 
      }
    }
  }

  componentWillUnmount() {
    this.stopTimer();
  }

  alertRaiser = ()=>{
    Alert.warning('Data has already been added to the Daily Summary. If you proceed, the existing Daily Summary data will be overwritten.', {
        position: 'bottom-right',
        effect: 'slide',
        timeout: 10000,
        customFields: {
          displayComponent: true,
          handleButtonClick: this.startTimer,
          // id: obj.id,
        },
      });
 }

  checkTimer = () => {
    // const time = 8 * 60 * 60;
    // const time = 3 * 60;
    if (this.state.seconds > MAX_DURATION_TIME) {
      this.props.submitData({
        id: this.props.id,
        seconds: this.state.seconds,
        isRunning: this.state.isRunning,
        wasPaused: this.state.wasPaused,
        userID: this.props.userID,
        patientID: this.props.patientID,
      });
      this.resetTimer();
    }
  };

  startTimer = () => {
    Alert.closeAll()
    this.intervalId = setInterval(() => {
      this.setState((prevState) => ({ seconds: prevState.seconds + 1 }));
      this.checkTimer();
      this.saveTimerState();
    }, 1000);
    this.setState({ isRunning: true, wasPaused: false });
  };

  stopTimer = () => {
    clearInterval(this.intervalId);
    this.setState({ isRunning: false, wasPaused: true },()=>{
      const timerState = {
        seconds: this.state.seconds,
        isRunning: this.state.isRunning,
        wasPaused: this.state.wasPaused,
        userID: this.props.userID,
        patientID: this.props.patientID,
        lastUpdateTime: Date.now()
      };
      localStorage.setItem(this.storageKey, JSON.stringify(timerState));
    });
  };

  resetTimer = () => {
    this.stopTimer();
    this.setState({ seconds: 0, isRunning: false, wasPaused: false },()=>{
        this.saveTimerState();
    });
  };

  saveTimerState = () => {
    const timerState = {
      seconds: this.state.seconds,
      isRunning: this.state.isRunning,
      wasPaused: this.state.wasPaused,
      userID: this.props.userID,
      patientID: this.props.patientID,
      lastUpdateTime: Date.now()
    };
    localStorage.setItem(this.storageKey, JSON.stringify(timerState));
  };

  saveTimer = () => { 
    console.log("save Timer");
    // this.resetTimer();
    this.props.submitData({
      id: this.props.id,
      seconds: this.state.seconds,
      isRunning: this.state.isRunning,
      wasPaused: this.state.wasPaused,
      userID: this.props.userID,
      patientID: this.props.patientID,
    });
    this.setState({ seconds: 0, isRunning: false, wasPaused: false },()=>{
        this.saveTimerState();
    });
  }

  onCancel = () => {
    this.stopTimer();
    this.setState({ seconds: 0, isRunning: false, wasPaused: false },()=>{
      const timerState = {
        seconds: this.state.seconds,
        isRunning: this.state.isRunning,
        wasPaused: this.state.wasPaused,
        userID: this.props.userID,
        patientID: this.props.patientID,
        lastUpdateTime: Date.now()
      };
      localStorage.setItem(this.storageKey, JSON.stringify(timerState));
    });
    Alert.closeAll();
  }


  handleCancelConfirmation = () => {
    alertConfirmation('Are you sure you want to cancel Duration Details?', {
        customFields: {
            displayComponent: true,
            handleButtonClick: () => this.onCancel(),
        }
    });
  }
  callAlertOrTimer = () => {
    for (const ele of this.props.PatientBehaviorsReductionData) {
        if (ele.id === this.props.id && ele.isDataCollectedInDailySummaryData) {
            this.alertRaiser();
            return; // Exits the outer function
        }
    }
    this.startTimer(); // Only runs if the condition above was not met
};

  render() {
    return (
      <div style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems:"center"
        }}>
      <div style={{marginRight:"10px"}}>
        {(!this.state.isRunning && !this.state.wasPaused) && (
          <RaisedButton
            className="ml_15 startButton"
            label="Start"
            primary={true}
            onClick={this.callAlertOrTimer}  
            ></RaisedButton>)}        
          { this.state.isRunning && (
          <RaisedButton
          className="ml_15 stopButton"
          label="Stop"
          primary={true}
          onClick={this.stopTimer}></RaisedButton>)}
        { this.state.wasPaused && (
          <RaisedButton
          className="ml_15"
          label="Save"
          primary={true}
          onClick={this.saveTimer}></RaisedButton>)}
        {
          (this.state.wasPaused || this.state.isRunning) && (
            <RaisedButton
            className="ml_15 cancelButton"
            label="Cancel"
            primary={true}
            onClick={()=>this.handleCancelConfirmation()}
            ></RaisedButton>
          )
        }
      </div>


         {/* (<button onClick={this.startTimer}>Start Timer</button>)
         (<button onClick={this.stopTimer}>Pause Timer</button>)
         (<button onClick={this.saveTimer}>onSave</button>)
         <button onClick={this.resetTimer}>Reset Timer</button> */}
        <span>{formatTime(this.state.seconds)}</span>
      </div>
    );
  }
}

export default Timer;


// WEBPACK FOOTER //
// ./src/modules/patients/components/collectData/componnets/BehaviorData/components/RecordDuration/Timer.js